import MaterialNameStack from '#/modules/imsMgmt/receipts/shared/MaterialNameStack';
import { formatOriginalSerialList } from '#/modules/imsMgmt/settings/mtr/helper/mtrFilterOptions';

export function renderOriginalSerialScannedRow(row) {
  return (
    <div className="min-w-0 flex items-center gap-5">
      <MaterialNameStack
        name={row.name}
        code={row.mtrNo}
      />
      <p className="text-sm text-muted-foreground">
        原廠料號:
        {' '}
        {formatOriginalSerialList(row.originalSerialList)}
      </p>
    </div>
  );
}

export function renderOriginalSerialAmbiguousRow(row) {
  return (
    <div className="min-w-0 space-y-1">
      <p className="font-mono text-sm font-medium text-slate-800">
        {row.mtrNo || '—'}
      </p>
      <p className="truncate text-sm text-slate-700">
        {row.name || '—'}
      </p>
      <p className="text-xs text-muted-foreground">
        原廠料號
        {' '}
        {formatOriginalSerialList(row.originalSerialList)}
      </p>
    </div>
  );
}
